import ProjectCard from "../components/ProjectCard/ProjectCard";
import bardownDescription from "../static/bardownDescription.md";
import digitalCouponsDescription from "../static/digitalCouponsDescription.md";
import azure from "../static/images/azure.png";
import spokaneEconomicDashboard from "../static/images/dashboard.png";
import docker from "../static/images/docker.png";
import go from "../static/images/go.png";
import bardown from "../static/images/bardown.png";
import java from "../static/images/java.png";
import k3s from "../static/images/k3s.png";
import server from "../static/images/server.png";
import k8s from "../static/images/k8s.png";
import kafka from "../static/images/kafka.png";
import kroger from "../static/images/kroger-tech.jpeg";
import node from "../static/images/node.png";
import nosql from "../static/images/nosql-dark.png";
import python from "../static/images/python.png";
import rmq from "../static/images/RabbitMQ.png";
import sql from "../static/images/sql.png";
import spokaneEconomicDashboardDescription from "../static/spokaneEconomicDashboardDescription.md";
import "../stylesheets/projects.css";

export default function ProjectsPage() {
  return (
    <div className="Projects">
      <ProjectCard
        content={{
          title: "Digital Coupons Modernization",
          subtitle: "Kroger Technology & Digital",
          projectImageRefs: [kroger],
          projectIconRefs: [java, go, sql, nosql, kafka, docker, k8s, azure],
          projectDescriptionPath: digitalCouponsDescription,
          buttonMap: [],
        }}
      />
      <ProjectCard
        content={{
          title: "Spokane Economic Dashboard",
          subtitle: "Gonzaga Senior Capstone Project",
          projectDescriptionPath: spokaneEconomicDashboardDescription,
          projectImageRefs: [spokaneEconomicDashboard],
          projectIconRefs: [python, node, nosql, docker],
          buttonMap: [
            {
              title: "GitHub Repo",
              targetUrl: "https://www.github.com/zfoteff/",
            },
          ],
        }}
      />
      <ProjectCard
        content={{
          title: "Raspberry Pi Kubernetes Cluster",
          subtitle: "Self-hosted Kubernetes Cluster Using K3s",
          projectImageRefs: [server],
          projectIconRefs: [python, go, k3s],
          projectDescriptionPath: digitalCouponsDescription,
          buttonMap: [],
        }}
      />
      <ProjectCard
        content={{
          title: "BarDown",
          subtitle: "Statistic Tracking App for Nelson Hawks Lacrosse Team",
          projectImageRefs: [bardown],
          projectIconRefs: [python, docker, sql, rmq],
          projectDescriptionPath: bardownDescription,
          buttonMap: [
            {
              title: "GitHub Repo",
              targetUrl: "https://www.github.com/zfoteff/bardown",
            },
          ],
        }}
      />
    </div>
  );
}
